import request from '@/utils/request'

/**
 * 获取分销规则列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function listAffiliateRule(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/affiliateRule.listAffiliateRule',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 添加分销规则
 * @param {Object} data 分销规则数据
 * @returns {Promise} Promise对象
 */
export function saveAffiliateRule(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/affiliateRule.saveAffiliateRule',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 更新分销规则
 * @param {Object} data 分销规则数据
 * @returns {Promise} Promise对象
 */
export function updateAffiliateRule(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/affiliateRule.updateAffiliateRule',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除分销规则
 * @param {Object} data 分销规则数据
 * @returns {Promise} Promise对象
 */
export function deleteAffiliateRule(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/affiliateRule.deleteAffiliateRule',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}